(function () {
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const toast = document.getElementById('toast');
  const toastMsg = document.getElementById('toastMsg');
  const cartItemsContainer = document.querySelector('[data-cart-items]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartEditModal = document.getElementById('cartEditModal');
  const cartEditContent = document.querySelector('[data-cart-edit-content]');
  const searchDrawer = document.getElementById('searchDrawer');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchDrawerInput = document.querySelector('[data-search-drawer-input]');
  const searchDrawerForm = searchDrawer ? searchDrawer.querySelector('.search-drawer-form') : null;
  const searchDrawerHeading = document.querySelector('[data-search-drawer-heading]');
  const searchDrawerResults = document.querySelector('[data-search-drawer-results]');
  const searchViewAll = document.querySelector('[data-search-view-all]');
  const defaultSearchHeading = searchDrawerHeading ? searchDrawerHeading.textContent : '';
  const defaultSearchResults = searchDrawerResults ? searchDrawerResults.innerHTML : '';
  let searchDebounceTimer = null;
  let activeSearchController = null;
  let activeCartEdit = null;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    const activeCurrency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      let formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency
      }).format((cents || 0) / 100);
      formatted = formatted.replace(/\s?US\$/i, '$').replace(/\s?USD/i, '');
      return formatted;
    } catch (error) {
      return `$${((cents || 0) / 100).toFixed(2)}`;
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((item) => {
      item.textContent = count;
    });
  }

  const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');

  function openMobileMenu() {
    if (!mobileMenuDrawer) return;
    mobileMenuDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-menu-open', 'modal-open');
  }

  function closeMobileMenu() {
    if (!mobileMenuDrawer) return;
    mobileMenuDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-menu-open', 'modal-open');
  }

  function openSearchDrawer() {
    if (!searchDrawer || !searchOverlay) return;
    closeMobileMenu();
    searchDrawer.classList.add('open');
    searchOverlay.classList.add('open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    window.setTimeout(() => {
      if (!searchDrawerInput) return;
      searchDrawerInput.focus();
      if (searchDrawerInput.value.trim()) searchDrawerProducts(searchDrawerInput.value);
    }, 80);
  }

  function closeSearchDrawer() {
    if (!searchDrawer || !searchOverlay) return;
    searchDrawer.classList.remove('open');
    searchOverlay.classList.remove('open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  function getSearchUrl(query) {
    const baseUrl = searchDrawerForm ? searchDrawerForm.getAttribute('action') : '/search';
    return `${baseUrl}?q=${encodeURIComponent(query)}&type=product`;
  }

  function getPredictiveSearchPrice(product) {
    if (!product) return '';
    if (product.price) return String(product.price);
    if (product.price_min) return String(product.price_min);
    if (product.price_varies && product.compare_at_price_min) return String(product.compare_at_price_min);
    return '';
  }

  function getPredictiveSearchImage(product) {
    if (!product || !product.image) return '';
    if (typeof product.image === 'string') return product.image;
    return product.image.url || product.image.src || '';
  }

  function renderPredictiveProducts(products) {
    if (!searchDrawerResults) return;

    if (!products || products.length === 0) {
      searchDrawerResults.innerHTML = '<p class="search-empty-message">No products found.</p>';
      return;
    }

    searchDrawerResults.innerHTML = products.map((product) => {
      const imageUrl = getPredictiveSearchImage(product);
      const price = getPredictiveSearchPrice(product);
      const title = product.title || product.product_title || '';
      const url = product.url || '#';

      return `
        <a class="search-suggestion-item" href="${escapeHtml(url)}">
          <span class="search-suggestion-image">
            ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" loading="lazy" alt="${escapeHtml(title)}">` : ''}
          </span>
          <span class="search-suggestion-info">
            <strong>${escapeHtml(title)}</strong>
            ${price ? `<span>${escapeHtml(price)}</span>` : ''}
          </span>
        </a>
      `;
    }).join('');
  }

  function resetSearchDrawerResults() {
    if (activeSearchController) activeSearchController.abort();
    if (searchDrawerHeading) searchDrawerHeading.textContent = defaultSearchHeading;
    if (searchDrawerResults) searchDrawerResults.innerHTML = defaultSearchResults;
    if (searchViewAll) {
      searchViewAll.hidden = true;
      searchViewAll.href = searchDrawerForm ? searchDrawerForm.getAttribute('action') : '/search';
      searchViewAll.textContent = 'View All Results →';
    }
    if (searchDrawer) searchDrawer.classList.remove('is-searching');
  }

  function updateSearchViewAll(query, count) {
    if (!searchViewAll) return;
    searchViewAll.hidden = false;
    searchViewAll.href = getSearchUrl(query);
    searchViewAll.textContent = count ? `View All (${count}) →` : 'View All Results →';
  }

  function searchDrawerProducts(query) {
    const term = query.trim();
    if (!term) {
      resetSearchDrawerResults();
      return;
    }

    if (searchDrawerHeading) searchDrawerHeading.textContent = 'Search Results:';
    if (searchDrawerResults) searchDrawerResults.innerHTML = '<p class="search-loading-message">Searching...</p>';
    updateSearchViewAll(term);
    if (searchDrawer) searchDrawer.classList.add('is-searching');
    if (activeSearchController) activeSearchController.abort();
    activeSearchController = new AbortController();

    fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=4`, {
      headers: { Accept: 'application/json' },
      signal: activeSearchController.signal
    })
      .then((response) => {
        if (!response.ok) throw new Error('Search failed');
        return response.json();
      })
      .then((data) => {
        const resources = data.resources || {};
        const results = resources.results || {};
        const count = resources.results_count && resources.results_count.products;
        renderPredictiveProducts(results.products || []);
        updateSearchViewAll(term, count);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        if (searchDrawerResults) {
          searchDrawerResults.innerHTML = '<p class="search-empty-message">Search is taking longer than expected. View all results instead.</p>';
        }
      })
      .finally(() => {
        if (searchDrawer) searchDrawer.classList.remove('is-searching');
      });
  }

  document.querySelectorAll('[data-mobile-menu-open]').forEach((button) => {
    button.addEventListener('click', openMobileMenu);
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', closeMobileMenu);
  });

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.mobile-menu-item');
      if (!item) return;
      item.classList.toggle('open');
    });
  });

  document.querySelectorAll('[data-search-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      if (button.closest('.header-search') && window.innerWidth > 980) return;
      event.preventDefault();
      openSearchDrawer();
    });
  });

  document.querySelectorAll('[data-search-close]').forEach((button) => {
    button.addEventListener('click', closeSearchDrawer);
  });

  document.querySelectorAll('[data-footer-accordion-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('[data-footer-accordion]');
      if (!section) return;
      const isOpen = section.classList.toggle('open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-products-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-products-carousel-track]');
    const prevButton = carousel.querySelector('[data-products-carousel-prev]');
    const nextButton = carousel.querySelector('[data-products-carousel-next]');
    if (!track) return;

    function getScrollDistance() {
      const firstCard = track.querySelector('.product-card');
      if (!firstCard) return track.clientWidth;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
      return firstCard.getBoundingClientRect().width + gap;
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
      });
    }
  });

  if (searchDrawerInput) {
    searchDrawerInput.addEventListener('input', () => {
      window.clearTimeout(searchDebounceTimer);
      searchDebounceTimer = window.setTimeout(() => {
        searchDrawerProducts(searchDrawerInput.value);
      }, 220);
    });
  }

  if (searchDrawerForm) {
    searchDrawerForm.addEventListener('submit', (event) => {
      const query = searchDrawerInput ? searchDrawerInput.value.trim() : '';
      if (!query) {
        event.preventDefault();
        resetSearchDrawerResults();
        return;
      }
      event.preventDefault();
      window.location.href = getSearchUrl(query);
    });
  }

  function renderCartDrawer(cart) {
    if (!cart) return;
    updateCartCount(cart.item_count || 0);

    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price, cart.currency);
    }

    if (!cartItemsContainer) return;

    if (!cart.items || cart.items.length === 0) {
      cartItemsContainer.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">🛒</div>
          <h4>Your cart is empty</h4>
          <p>Start with a family favorite.</p>
        </div>
      `;
      return;
    }

    cartItemsContainer.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" loading="lazy" alt="${escapeHtml(item.product_title)}">`
        : '';
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `${escapeHtml(item.variant_title)} · `
        : '';

      return `
        <div class="cart-item">
          <a class="cart-item-image" href="${escapeHtml(item.url)}">${image}</a>
          <div class="cart-item-info">
            <h5><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h5>
            <p>${variantTitle}Qty: ${item.quantity}</p>
            <div class="cart-item-price">${formatMoney(item.final_line_price, cart.currency)}</div>
            <div class="cart-item-actions">
              <button class="cart-item-action" type="button" data-cart-edit="${escapeHtml(item.key)}" aria-label="Edit item">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              </button>
              <button class="cart-item-action" type="button" data-cart-remove="${escapeHtml(item.key)}" aria-label="Remove item">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 15H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function setCartDrawerLoading(isLoading) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-updating', isLoading);
  }

  function getCartItemByKey(key) {
    return refreshCartDrawer().then((cart) => (cart.items || []).find((item) => item.key === key));
  }

  function closeCartEditModal() {
    if (!cartEditModal) return;
    cartEditModal.classList.remove('open');
    cartEditModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    activeCartEdit = null;
  }

  function findVariantByOptions(product, selectedOptions) {
    return product.variants.find((variant) => {
      return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
    });
  }

  function renderCartEditModal(item, product) {
    if (!cartEditContent || !cartEditModal) return;
    const selectedOptions = item.variant_options && item.variant_options.length
      ? item.variant_options.slice()
      : (product.variants.find((variant) => variant.id === item.variant_id) || product.variants[0]).options.slice();
    const activeVariant = findVariantByOptions(product, selectedOptions) || product.variants[0];
    activeCartEdit = { item, product, selectedOptions, quantity: item.quantity, variant: activeVariant };

    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">`
      : '';
    const optionsMarkup = product.options.map((optionName, optionIndex) => {
      const values = Array.from(new Set(product.variants.map((variant) => variant.options[optionIndex])));
      return `
        <div class="cart-edit-option">
          <div class="cart-edit-label">${escapeHtml(optionName)}: <strong data-cart-edit-selected="${optionIndex}">${escapeHtml(selectedOptions[optionIndex])}</strong></div>
          <div class="cart-edit-values">
            ${values.map((value) => `
              <button
                class="cart-edit-value${value === selectedOptions[optionIndex] ? ' active' : ''}"
                type="button"
                data-cart-edit-option="${optionIndex}"
                data-cart-edit-value="${escapeHtml(value)}"
              >${escapeHtml(value)}</button>
            `).join('')}
          </div>
        </div>
      `;
    }).join('');

    cartEditContent.innerHTML = `
      <div class="cart-edit-product">
        <div class="cart-edit-image">${image}</div>
        <div>
          <h3 id="cartEditTitle">${escapeHtml(item.product_title)}</h3>
          <div class="cart-edit-price">${formatMoney(activeVariant.price)}</div>
        </div>
      </div>
      ${optionsMarkup}
      <div class="cart-edit-qty">
        <button type="button" data-cart-edit-qty-minus>−</button>
        <input type="number" min="1" value="${item.quantity}" data-cart-edit-qty aria-label="Quantity">
        <button type="button" data-cart-edit-qty-plus>+</button>
      </div>
      <button class="cart-edit-submit" type="button" data-cart-edit-submit>Update Item</button>
      <a class="cart-edit-full-details" href="${escapeHtml(item.url)}">View full details →</a>
    `;

    cartEditModal.classList.add('open');
    cartEditModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function openCartEditModal(key) {
    getCartItemByKey(key)
      .then((item) => {
        if (!item || !item.handle) throw new Error('Cart item not found');
        return fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((product) => renderCartEditModal(item, product));
      })
      .catch(() => {
        showToast('Could not open item editor.');
      });
  }

  function updateCartEditSelection(optionIndex, value) {
    if (!activeCartEdit) return;
    activeCartEdit.selectedOptions[optionIndex] = value;
    activeCartEdit.variant = findVariantByOptions(activeCartEdit.product, activeCartEdit.selectedOptions);

    cartEditContent.querySelectorAll(`[data-cart-edit-option="${optionIndex}"]`).forEach((button) => {
      button.classList.toggle('active', button.dataset.cartEditValue === value);
    });
    const selectedLabel = cartEditContent.querySelector(`[data-cart-edit-selected="${optionIndex}"]`);
    if (selectedLabel) selectedLabel.textContent = value;
    const price = cartEditContent.querySelector('.cart-edit-price');
    if (price && activeCartEdit.variant) price.textContent = formatMoney(activeCartEdit.variant.price);
  }

  function submitCartEdit() {
    if (!activeCartEdit || !activeCartEdit.variant) {
      showToast('This option combination is unavailable.');
      return;
    }
    const quantityInput = cartEditContent.querySelector('[data-cart-edit-qty]');
    const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value ? quantityInput.value : activeCartEdit.quantity, 10));
    const submitButton = cartEditContent.querySelector('[data-cart-edit-submit]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Updating...';
    }

    removeCartItem(activeCartEdit.item.key)
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: activeCartEdit.variant.id, quantity })
      }))
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed');
        openCart({ refresh: false });
        setCartDrawerLoading(true);
        return refreshCartDrawer();
      })
      .then(() => {
        setCartDrawerLoading(false);
        closeCartEditModal();
        showToast('Cart item updated.');
      })
      .catch(() => {
        setCartDrawerLoading(false);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Update Item';
        }
        showToast('Could not update item. Please try again.');
      });
  }

  function removeCartItem(key) {
    if (!key) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart remove failed');
        return response.json();
      })
      .then((cart) => {
        renderCartDrawer(cart);
        return cart;
      });
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        renderCartDrawer(cart);
        return cart;
      });
  }

  function openCart(options = {}) {
    if (!cartDrawer || !cartOverlay) return;
    if (options.refresh !== false) {
      refreshCartDrawer().catch(() => {});
    }
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('open');
  }

  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('open');
  }

  function showToast(message) {
    if (!toast || !toastMsg) return;
    toastMsg.textContent = message;
    toast.classList.add('show');
    window.clearTimeout(window.cozyToastTimer);
    window.cozyToastTimer = window.setTimeout(() => toast.classList.remove('show'), 3000);
  }

  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', openCart);
  });

  document.querySelectorAll('[data-cart-close]').forEach((button) => {
    button.addEventListener('click', closeCart);
  });

  if (cartItemsContainer) {
    cartItemsContainer.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-cart-remove]');
      const editButton = event.target.closest('[data-cart-edit]');
      if (editButton) {
        openCartEditModal(editButton.dataset.cartEdit);
        return;
      }
      if (!removeButton) return;
      removeButton.disabled = true;
      setCartDrawerLoading(true);
      removeCartItem(removeButton.dataset.cartRemove)
        .then(() => {
          setCartDrawerLoading(false);
        })
        .catch(() => {
          setCartDrawerLoading(false);
          removeButton.disabled = false;
          showToast('Could not remove item. Please try again.');
        });
    });
  }

  document.querySelectorAll('[data-cart-edit-close]').forEach((button) => {
    button.addEventListener('click', closeCartEditModal);
  });

  if (cartEditContent) {
    cartEditContent.addEventListener('click', (event) => {
      const optionButton = event.target.closest('[data-cart-edit-option]');
      if (optionButton) {
        updateCartEditSelection(parseInt(optionButton.dataset.cartEditOption, 10), optionButton.dataset.cartEditValue);
        return;
      }

      const minusButton = event.target.closest('[data-cart-edit-qty-minus]');
      const plusButton = event.target.closest('[data-cart-edit-qty-plus]');
      const quantityInput = cartEditContent.querySelector('[data-cart-edit-qty]');
      if (minusButton && quantityInput) {
        quantityInput.value = Math.max(1, parseInt(quantityInput.value || '1', 10) - 1);
        return;
      }
      if (plusButton && quantityInput) {
        quantityInput.value = parseInt(quantityInput.value || '1', 10) + 1;
        return;
      }

      if (event.target.closest('[data-cart-edit-submit]')) {
        submitCartEdit();
      }
    });
  }

  document.querySelectorAll('[data-announcement-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const bar = document.getElementById('annBar');
      if (bar) bar.style.display = 'none';
    });
  });

  document.querySelectorAll('[data-accordion-header]').forEach((header) => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isOpen = content.classList.contains('open');
      document.querySelectorAll('.accordion-content').forEach((item) => item.classList.remove('open'));
      document.querySelectorAll('.accordion-header span').forEach((span) => { span.textContent = '+'; });
      if (!isOpen) {
        content.classList.add('open');
        const span = header.querySelector('span');
        if (span) span.textContent = '−';
      }
    });
  });

  const productThumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));
  const mainProductImage = document.getElementById('mainProductImage');
  const mainImageWrap = mainProductImage ? mainProductImage.closest('.main-image') : null;
  let activeGalleryIndex = Math.max(0, productThumbs.findIndex((thumb) => thumb.classList.contains('active')));
  let galleryIsAnimating = false;
  const preloadedGalleryImages = new Map();

  function preloadGalleryImage(url) {
    if (!url) return Promise.resolve();
    if (preloadedGalleryImages.has(url)) return preloadedGalleryImages.get(url);

    const preloadPromise = new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        if (image.decode) {
          image.decode().then(resolve).catch(resolve);
        } else {
          resolve();
        }
      };
      image.onerror = resolve;
      image.src = url;
    });

    preloadedGalleryImages.set(url, preloadPromise);
    return preloadPromise;
  }

  function warmGalleryImages() {
    if (!productThumbs.length) return;

    const priorityIndexes = [
      activeGalleryIndex + 1,
      activeGalleryIndex - 1
    ];

    priorityIndexes.forEach((index) => {
      const thumb = productThumbs[(index + productThumbs.length) % productThumbs.length];
      if (thumb) preloadGalleryImage(thumb.dataset.productThumb);
    });

    const preloadRest = () => {
      productThumbs.forEach((thumb) => preloadGalleryImage(thumb.dataset.productThumb));
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadRest, { timeout: 1800 });
    } else {
      window.setTimeout(preloadRest, 700);
    }
  }

  function showGalleryImage(index, direction = 1) {
    if (!mainProductImage || productThumbs.length === 0 || galleryIsAnimating) return;
    const nextGalleryIndex = (index + productThumbs.length) % productThumbs.length;
    if (nextGalleryIndex === activeGalleryIndex) return;
    const activeThumb = productThumbs[nextGalleryIndex];
    const nextImageUrl = activeThumb.dataset.productThumb;
    if (!nextImageUrl) return;

    galleryIsAnimating = true;

    preloadGalleryImage(nextImageUrl).then(() => {
      const galleryFrame = mainProductImage.parentElement;
      const nextImage = mainProductImage.cloneNode(false);
      nextImage.removeAttribute('id');
      nextImage.removeAttribute('srcset');
      nextImage.removeAttribute('sizes');
      nextImage.src = nextImageUrl;
      nextImage.alt = activeThumb.dataset.productThumbAlt || mainProductImage.alt || '';
      nextImage.style.position = 'absolute';
      nextImage.style.inset = '0';
      nextImage.style.width = '100%';
      nextImage.style.height = '100%';
      nextImage.style.objectFit = 'contain';
      nextImage.style.transform = `translateX(${direction > 0 ? '100%' : '-100%'})`;
      nextImage.style.transition = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      nextImage.style.zIndex = '2';

      activeGalleryIndex = nextGalleryIndex;
      productThumbs.forEach((item) => item.classList.remove('active'));
      activeThumb.classList.add('active');
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      mainProductImage.style.transition = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      mainProductImage.style.transform = 'translateX(0)';
      mainProductImage.style.zIndex = '1';
      galleryFrame.appendChild(nextImage);

      window.requestAnimationFrame(() => {
        mainProductImage.style.transform = `translateX(${direction > 0 ? '-100%' : '100%'})`;
        nextImage.style.transform = 'translateX(0)';
      });

      window.setTimeout(() => {
        mainProductImage.removeAttribute('srcset');
        mainProductImage.removeAttribute('sizes');
        mainProductImage.src = nextImageUrl;
        if (activeThumb.dataset.productThumbAlt) {
          mainProductImage.alt = activeThumb.dataset.productThumbAlt;
        }
        mainProductImage.style.transition = 'none';
        mainProductImage.style.transform = 'translateX(0)';
        mainProductImage.style.zIndex = '';
        nextImage.remove();
        galleryIsAnimating = false;
        warmGalleryImages();
      }, 340);
    }).catch(() => {
      galleryIsAnimating = false;
    });
  }

  warmGalleryImages();

  productThumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      const direction = index > activeGalleryIndex ? 1 : -1;
      showGalleryImage(index, direction);
    });
  });

  document.querySelectorAll('[data-gallery-prev]').forEach((button) => {
    button.addEventListener('click', () => showGalleryImage(activeGalleryIndex - 1, -1));
  });

  document.querySelectorAll('[data-gallery-next]').forEach((button) => {
    button.addEventListener('click', () => showGalleryImage(activeGalleryIndex + 1, 1));
  });

  if (mainImageWrap) {
    let touchStartX = 0;
    let touchStartY = 0;

    mainImageWrap.addEventListener('touchstart', (event) => {
      if (!event.changedTouches.length) return;
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });

    mainImageWrap.addEventListener('touchend', (event) => {
      if (!event.changedTouches.length) return;
      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (deltaX < 0) {
        showGalleryImage(activeGalleryIndex + 1, 1);
      } else {
        showGalleryImage(activeGalleryIndex - 1, -1);
      }
    });
  }

  document.querySelectorAll('[data-product-info-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.dataset.productInfoToggle;
      const panel = document.querySelector(`[data-product-info-panel="${target}"]`);
      const isOpen = panel && panel.classList.contains('open');

      document.querySelectorAll('[data-product-info-toggle]').forEach((item) => item.classList.remove('active'));
      document.querySelectorAll('[data-product-info-panel]').forEach((item) => item.classList.remove('open'));

      if (panel && !isOpen) {
        button.classList.add('active');
        panel.classList.add('open');
      }
    });
  });

  function closeProductPageModals() {
    document.querySelectorAll('.product-page-modal.open').forEach((modal) => {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('modal-open');
  }

  document.querySelectorAll('[data-product-page-modal-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const modal = document.getElementById(button.dataset.productPageModalOpen);
      if (!modal) return;
      closeProductPageModals();
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      const closeButton = modal.querySelector('[data-product-page-modal-close]');
      if (closeButton) closeButton.focus();
    });
  });

  document.querySelectorAll('[data-product-page-modal-close]').forEach((button) => {
    button.addEventListener('click', closeProductPageModals);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSearchDrawer();
      closeMobileMenu();
      closeProductPageModals();
      closeCartEditModal();
    }
  });

  document.querySelectorAll('[data-qty-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.qty-control').querySelector('input');
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.qty-control').querySelector('input');
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  const productJson = document.querySelector('[data-product-json]');
  const productForm = document.querySelector('.product-form');
  if (productJson && productForm) {
    const product = JSON.parse(productJson.textContent);
    const selectedOptions = {};

    product.options.forEach((name, index) => {
      const active = document.querySelector(`[data-option-position="${index + 1}"].active`);
      selectedOptions[index + 1] = active ? active.dataset.optionValue : product.variants[0].options[index];
    });

    function updateSelectedColorName() {
      const colorOptionIndex = product.options.findIndex((name) => /colou?r/i.test(name));
      const colorName = document.querySelector('[data-selected-color-name]');
      if (colorOptionIndex === -1 || !colorName) return;
      colorName.textContent = selectedOptions[colorOptionIndex + 1] || '';
    }

    function updateVariant() {
      const variant = product.variants.find((item) => {
        return item.options.every((value, index) => value === selectedOptions[index + 1]);
      });
      if (!variant) return;

      const idInput = productForm.querySelector('input[name="id"]');
      const addButton = productForm.querySelector('.btn-addcart');
      if (idInput) idInput.value = variant.id;
      if (addButton) {
        addButton.classList.remove('is-loading');
        addButton.removeAttribute('aria-busy');
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to Cart 🛒' : 'Sold Out';
      }
      updateSelectedColorName();
    }

    function setAddButtonLoading(button, isLoading) {
      if (!button) return;
      if (isLoading) {
        button.dataset.originalText = button.textContent;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        return;
      }
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        delete button.dataset.originalText;
      }
    }

    document.querySelectorAll('[data-option-position]').forEach((button) => {
      button.addEventListener('click', () => {
        const position = button.dataset.optionPosition;
        selectedOptions[position] = button.dataset.optionValue;
        document.querySelectorAll(`[data-option-position="${position}"]`).forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        updateVariant();
      });
    });

    updateSelectedColorName();

    productForm.addEventListener('submit', (event) => {
      if (event.submitter && !event.submitter.classList.contains('btn-addcart')) return;
      event.preventDefault();
      const formData = new FormData(productForm);
      const addButton = event.submitter || productForm.querySelector('.btn-addcart');
      setAddButtonLoading(addButton, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart add failed');
          showToast('🛒 Added to cart!');
          openCart({ refresh: false });
          setCartDrawerLoading(true);
          return refreshCartDrawer();
        })
        .then(() => {
          setCartDrawerLoading(false);
          setAddButtonLoading(addButton, false);
        })
        .catch(() => {
          setCartDrawerLoading(false);
          setAddButtonLoading(addButton, false);
          HTMLFormElement.prototype.submit.call(productForm);
        });
    });
  }

  const recentlyViewedProductJson = document.querySelector('[data-current-product-view]');
  const recentlyViewedGrid = document.querySelector('[data-recently-viewed-grid]');
  const recentlyViewedSection = document.querySelector('[data-recently-viewed-section]');
  if (recentlyViewedProductJson && recentlyViewedGrid && recentlyViewedSection) {
    const storageKey = 'montara_recently_viewed_products';
    let currentProduct = null;
    let storedProducts = [];

    try {
      currentProduct = JSON.parse(recentlyViewedProductJson.textContent);
      storedProducts = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(storedProducts)) storedProducts = [];
    } catch (error) {
      storedProducts = [];
    }

    const visibleProducts = storedProducts
      .filter((item) => item && item.id && (!currentProduct || item.id !== currentProduct.id))
      .slice(0, 4);

    if (visibleProducts.length) {
      recentlyViewedGrid.innerHTML = visibleProducts.map((item) => {
        const hasSale = item.compareAtPrice && item.compareAtPrice > item.price;
        const priceHtml = hasSale
          ? `<span class="price-sale">${formatMoney(item.price)}</span><span class="price-old">${formatMoney(item.compareAtPrice)}</span>`
          : `<span class="price-current">${formatMoney(item.price)}</span>`;
        const imageHtml = item.image
          ? `<img src="${escapeHtml(item.image)}" loading="lazy" alt="${escapeHtml(item.title)}">`
          : '';

        return `
          <div class="product-card">
            <a href="${escapeHtml(item.url)}" class="product-image">
              ${hasSale ? '<div class="product-badge sale">Sale</div>' : ''}
              ${imageHtml}
              <span class="product-quickadd">Quick Add</span>
            </a>
            <div class="product-info">
              <div class="product-stars">${escapeHtml((item.ratingStars || '★★★★★').replace('½', '★'))} <span>(${escapeHtml(item.ratingCount || 12)})</span></div>
              <h4><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h4>
              <div class="product-price">${priceHtml}</div>
            </div>
          </div>
        `;
      }).join('');
      recentlyViewedSection.hidden = false;
    }

    if (currentProduct && currentProduct.id) {
      const nextProducts = [
        currentProduct,
        ...storedProducts.filter((item) => item && item.id !== currentProduct.id)
      ].slice(0, 12);
      try {
        localStorage.setItem(storageKey, JSON.stringify(nextProducts));
      } catch (error) {
        // Browsers can block localStorage in strict privacy mode.
      }
    }
  }

  document.querySelectorAll('[data-size-guide]').forEach((guide) => {
    const tabs = guide.querySelectorAll('[data-size-tab]');
    const panels = document.querySelectorAll('[data-size-panel]');
    const unitButtons = guide.querySelectorAll('[data-size-unit]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.sizeTab;
        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.classList.toggle('active', panel.dataset.sizePanel === target);
        });
      });
    });

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.sizeUnit;
        unitButtons.forEach((item) => item.classList.toggle('active', item === button));
        document.querySelectorAll('[data-size-table-unit]').forEach((table) => {
          table.classList.toggle('active', table.dataset.sizeTableUnit === unit);
        });
        document.querySelectorAll('[data-inch][data-cm]').forEach((cell) => {
          cell.textContent = unit === 'cm' ? cell.dataset.cm : cell.dataset.inch;
        });
      });
    });
  });
})();
